import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppConfig } from '../../../../app.config';

@Component({
  selector: 'app-jobcard-waiver',
  templateUrl: './jobcard-waiver.component.html',
  styleUrls: ['./jobcard-waiver.component.scss']
})
export class JobcardWaiverComponent implements OnInit {

  @Input() jobcard: any = {};
  @Input() partnerID: any = {};

  public waivers: any = [];
  public selectedTab: string = "";
  public loadingWaiver: boolean = false;
  public preServiceWaiver: any = null;
  public postServiceWaiver: any = null;
  public waiverConfig: any = null;

  public preServiceWaiverURL: any = "";
  public postServiceCustomerWaiverURL: any = "";
  public postServiceTechnicianWaiverURL: any = "";
  public postServiceManagerWaiverURL: any = "";
  public preServiceWaiverURLSafe: any = "";
  public postServiceCustomerWaiverURLSafe: any = "";
  public postServiceTechnicianWaiverURLSafe: any = "";
  public postServiceManagerWaiverURLSafe: any = "";


  constructor(
    private serviceRequest: ServiceRequestService,
    private sanitizer: DomSanitizer,
    private appConfig: AppConfig
  ) { }

  ngOnInit() {
    this.getJobCardWaiver();
  }

  getJobCardWaiver() {
    this.loadingWaiver = true;
    this.serviceRequest.getJobCardWaiver(this.partnerID, this.jobcard.ID, this.jobcard.IsFitting).subscribe((waivers: any) => {
      this.waiverConfig = waivers.waiverConfig;


      if (((this.jobcard.IsFitting && this.waiverConfig.preFittingWaiverRequired) || (!this.jobcard.IsFitting && this.waiverConfig.preServiceWaiverRequired) || (waivers.preServiceWaiver && waivers.preServiceWaiver.signatureURL)) && waivers.preServiceWaiver) {
        this.waivers.push({ tab: "PREWAIVER", label: this.jobcard.IsFitting ? 'bikeshop.plugins.widget.pre_fitting_waivers' : 'bikeshop.plugins.widget.pre_workshop_waivers' });
        this.selectedTab = "PREWAIVER";
        this.preServiceWaiverURL = this.appConfig.getWorkshopWidgetURL() + "/waivers/pre-service?waiverIdentifier=" + waivers.preServiceWaiver.webIdentifier + (this.appConfig.isDev() ? "&dev=true" : "");
        this.preServiceWaiverURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.getWorkshopWidgetURL() + "/waivers/pre-service?waiverIdentifier=" + waivers.preServiceWaiver.webIdentifier + (this.appConfig.isDev() ? "&dev=true" : ""));
      }
      if (((this.jobcard.IsFitting && this.waiverConfig.postFittingWaiverRequired) || (!this.jobcard.IsFitting && this.waiverConfig.postServiceWaiverRequired) || (waivers.postServiceWaiver && waivers.postServiceWaiver.signatureURL)) && waivers.postServiceWaiver) {
        this.waivers.push({ tab: "POSTWAIVER", label: this.jobcard.IsFitting ? 'bikeshop.plugins.widget.post_fitting_waivers' : 'bikeshop.plugins.widget.post_workshop_waivers' });
        if (!waivers.preServiceWaiver) {
          this.selectedTab = "POSTWAIVER";
        }
        this.postServiceCustomerWaiverURL = this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=1" + (this.appConfig.isDev() ? "&dev=true" : "");
        this.postServiceTechnicianWaiverURL = this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=2" + (this.appConfig.isDev() ? "&dev=true" : "");
        this.postServiceManagerWaiverURL = this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=3" + (this.appConfig.isDev() ? "&dev=true" : "");
        this.postServiceCustomerWaiverURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=1" + (this.appConfig.isDev() ? "&dev=true" : ""));
        this.postServiceTechnicianWaiverURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=2" + (this.appConfig.isDev() ? "&dev=true" : ""));
        this.postServiceManagerWaiverURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.getWorkshopWidgetURL() + "/waivers/post-service?waiverIdentifier=" + waivers.postServiceWaiver.webIdentifier + "&waiverType=3" + (this.appConfig.isDev() ? "&dev=true" : ""));
      }
      this.preServiceWaiver = waivers.preServiceWaiver;
      this.postServiceWaiver = waivers.postServiceWaiver;
      this.loadingWaiver = false;

    });
  }

}
